import React, { Component } from 'react';

import './Disclaimer.css';

const copyrightStyle = {fontWeight: 'bold',marginBottom:'10px'}
const disclaimerStyle = {display:'flex',flexDirection:'column'}

/* eslint-disable react/jsx-no-target-blank */
export default class Disclaimer extends Component {
    render() {
        var clientName = this.props.clientName;
        var stelterExtLink = `https://www.stelter.com?utm_campaign=gift-illustrator&utm_source=client-pg&utm_medium=${clientName}`;

        var annuityDisclaimer = (<b>
            &nbsp;Annuities are subject to regulation by the State of California. Payments under such agreements, however, are not protected or otherwise guaranteed by any government agency or the California Life and Health Insurance Guarantee Association. A charitable gift annuity is not regulated by the Oklahoma Insurance Department and is not protected by a guaranty association affiliated with the Oklahoma Insurance Department. Charitable gift annuities are not regulated by and are not under the jurisdiction of the South Dakota Division of Insurance.
        </b>);
        return (
            <div className="disclaimer" style={disclaimerStyle}>
                <span style={copyrightStyle}>Copyright &copy; <a href={stelterExtLink} target="_blank" rel="noopener">The Stelter Company</a>, All rights reserved.</span>
                <span>
                    The information on this website is not intended as legal or tax advice. For such advice, please consult an attorney or tax advisor. Figures cited in any examples are for illustrative purposes only. References to tax rates include federal taxes only and are subject to change. State law may further impact your individual results.
                    <span>
                        { this.props.annuity ? annuityDisclaimer : null }
                    </span>
                </span>
            </div>
        );
    }
}
